import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useFilter from '../hooks/useFilter';

export default function Archived() {
    const axiosPrivate = useAxiosPrivate();
    const { filter } = useFilter();
    const [loading, setLoading] = useState(true);
    const [hasArchivedCompletions, setHasArchivedCompletions] = useState(false);
    const [includeArchivedCompletions, setIncludeArchivedCompletions] = useState(true);
    const [helpText, setHelpText] = useState("");

    useEffect(() => {
        const getArchivedCheck = async () => {
            if (filter?.formHasArchivedCompletions)
            {
                if (filter.includeArchivedCompletions) {
                    setIncludeArchivedCompletions(filter.includeArchivedCompletions);
                }
            }
            else
            {
                try{
                    await axiosPrivate.get('/api/core/courses/checkarchived')
                        .then(response => {
                            setHasArchivedCompletions(response.data);
                        });
                }
                catch(err){
                    console.log(err);
                }
            }            
        };
        getArchivedCheck().then(function(){
            setLoading(false);
        });
    }, []);

    const onIncludeArchivedCompletionsChange = (e) => {
        setIncludeArchivedCompletions(e.target.checked);
    };  

    return ({
        loading, hasArchivedCompletions, includeArchivedCompletions, setHelpText,
        render:

            <>
                {
                    hasArchivedCompletions ?
                        <>
                            <Row>
                                <Col xs="6">
                                    <h5>Archived Data</h5>
                                    {helpText}
                                </Col>
                                <Col xs="6">
                                    <div>
                                        <input type='checkbox' onChange={onIncludeArchivedCompletionsChange} checked={includeArchivedCompletions} /> Include Archived Data
                                    </div>
                                </Col>
                            </Row>
                        </>
                        :
                        null
                }

            </>
    });
}